import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Typography, Table, TableBody, TableCell, TableRow, Grid, Rating, Divider, Avatar } from "@mui/material";
import { styled } from '@mui/material/styles';
import styles from './productdetails.module.css';
import { useDispatch, useSelector } from "react-redux";
import { getGoldRate } from "../../../../redux/homeSlice";
import { format, isToday, isYesterday, formatDistanceToNow } from "date-fns";

const TableCells = styled(TableCell)(({ theme }) => ({
    padding: '8px',
    fontSize: "12px",
    verticalAlign: 'top'
}));

const Typographys = styled(Typography)(({ theme }) => ({
    fontSize: "14px !important",
    "@media (max-width: 786px)": {
        fontSize: "13px !important",
    }
}));


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typographys>{children}</Typographys>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        "aria-controls": `tabpanel-${index}`,
    };
}


const ProductDetails = ({ productDetails }) => {

    const dispatch = useDispatch();
    const { goldRateData } = useSelector((state) => state.appearances);


    useEffect(() => {
        dispatch(getGoldRate())
    }, [dispatch])

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const GSTAmount = productDetails?.product?.pricing?.goldRate?.status === true ? productDetails?.product?.pricing?.goldRate?.value * productDetails?.product?.pricing?.gst?.value / 100 : 0

    const formattedDate = (date = new Date()) => {
        const dateFromMongoDB = new Date(date);

        if (isToday(dateFromMongoDB)) {
            return `Today, ${format(dateFromMongoDB, "hh:mm a")}`;
        } else if (isYesterday(dateFromMongoDB)) {
            return `Yesterday, ${format(dateFromMongoDB, "hh:mm a")}`;
        } else {
            const differenceInDays = Math.floor(
                (new Date() - dateFromMongoDB) / (1000 * 60 * 60 * 24)
            );
            if (differenceInDays < 7) {
                return `${formatDistanceToNow(dateFromMongoDB)} ago`;
            } else {
                const formattedDate = format(dateFromMongoDB, "dd MMM yyyy");
                const formattedTime = format(dateFromMongoDB, "hh:mm a");
                return `${formattedDate}, ${formattedTime}`;
            }
        }
    };

    const productUrl = window.location.href;
    const message = `Hello PAVITHRA JEWELS
Can I get more info on this product.
${productUrl}`;
    const encodedMessage = encodeURIComponent(message);
    return (
        <Box sx={{ width: "100%", typography: "body1", }}>

            <Typography mt={3}
                sx={{
                    fontSize: '24px',
                    color: '#3C4242',
                    fontWeight: 'bold',
                    lineHeight: '38px',
                    marginBottom: '12px',
                }}
            >
                Product Details
            </Typography>

            <div className={styles.descriptionHeading}>Description</div>

            <Box sx={{
                "& .MuiBox-root": {
                    padding: '0px',
                },
            }}>
                <TabPanel value={value} index={0} sx={{
                    "& .MuiBox-root": {
                        padding: '0px',
                    },
                }}>

                    <div style={{ fontSize: "14px", color: "#807D7E", lineHeight: "24px", marginTop: '20px', overflowY: 'auto' }} className={styles.hideScrollbar}
                        dangerouslySetInnerHTML={{ __html: productDetails?.product?.description || "" }} />

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '10px', marginTop: window.innerWidth >= 1024 ? '20px' : '20px', }}>
                        <a
                            href={`https://wa.me/919632429387?text=${encodedMessage}`} target="_blank" rel="noopener noreferrer">
                            <img src="/whatsappIcon.png" alt="whatsapp" style={{ width: 20, height: 20, cursor: 'pointer' }} />
                        </a>
                        <p style={{ fontSize: "14px", color: "#000", lineHeight: "24px", fontWeight: 'bold', }}>ENQUIRY</p>
                    </div>

                    <Typography sx={{
                        fontSize: "14px",
                        color: "#000",
                        lineHeight: "24px",
                        marginTop: '14px',
                        textDecoration: 'uppercase',
                        fontWeight: 'bold',
                    }}
                    >
                        PAVITHRA JEWELS, BASAVESHWARANAGAR,
                        <br />
                        BANGALORE, KARNATAKA - 560079, INDIA.
                    </Typography>
                    <Typography sx={{
                        fontSize: "14px",
                        color: "#000",
                        lineHeight: "24px",
                        marginTop: '4px',
                        fontWeight: 'bold'
                    }}>
                        We Ship all over India and Worldwide.
                    </Typography>
                </TabPanel>
            </Box>
        </Box>
    );
};

export default ProductDetails;
